import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import Select from "common/components/Select/Select";

export type ProcessOptionsType = (options: any[]) => {
  value: string;
  label: string;
}[];

function AnimalGenderSelect(props: any) {
  const { t } = useTranslation();

  const options = useMemo(
    () => [
      { label: t("animals.male"), value: "male" },
      { label: t("animals.female"), value: "female" },
      { label: t("animals.hybrid"), value: "hybrid" },
      { label: t("animals.hermaphrodite"), value: "hermaphrodite" },
      {
        label: t("animals.male_pseudohermaphrodite"),
        value: "male_pseudohermaphrodite",
      },
      {
        label: t("animals.female_pseudohermaphrodite"),
        value: "female_pseudohermaphrodite",
      },
      { label: t("animals.undetermined"), value: "undetermined" },
      { label: t("animals.undefinable"), value: "undefinable" },
    ],
    [t]
  );

  return <Select options={options} {...props} />;
}

export default AnimalGenderSelect;
